import { SupplierType } from "../../../../config/enums/SupplierType.enum";
import { IngredientRowViewModel } from "../types/ingredientListView.types";

/**
 * Single-responsibility mapper: turns one raw `/ingredient/list` API record
 * into the typed `IngredientRowViewModel` the presentation layer renders.
 *
 * Mirrors the inline mapping in the legacy `loadTableData` (see
 * src/screens/ingredients/ingredientList/IngredientList.tsx) exactly, so the
 * grid keeps showing the same data — only the shaping logic moved into its
 * own, independently testable unit.
 */
export class IngredientRowMapper {
  static toRowViewModel(ingredient: any): IngredientRowViewModel {
    return {
      ingredient_id: ingredient?._id,
      ingredient_name: ingredient?.ingredient_name,
      supplier_id: ingredient?.suppliers?._id || null,
      supplier_name: ingredient?.suppliers?.supplier_name,
      supplier_type: ingredient?.suppliers?.supplier_type || SupplierType.External,
      supplierAsUser: ingredient?.suppliers?.is_supplier_as_user || false,
      supplierIngredientDetails:
        ingredient?.suppliers?.supplierIngredientDetails?.find(
          (ingDetail: any) => ingDetail?.ingredient_id === ingredient?._id
        ) || null,
      ingredientProductIds: ingredient?.productIds || [],
      supplierProductIds: ingredient?.suppliers?.productIds || [],
      supplierIngredientIds: ingredient?.suppliers?.ingredientIds || [],
      supplierCount: ingredient?.supplierCount || 0,
      ingredient_image_path: ingredient?.ingredient_image_path
    };
  }

  static toRowViewModels(ingredients: any[] | undefined): IngredientRowViewModel[] {
    return (ingredients || []).map(ingredient => IngredientRowMapper.toRowViewModel(ingredient));
  }
}
